import React, { useState, useContext, useCallback } from 'react';
import styled from 'styled-components';

import { useBreakpoint } from 'hooks';
import TourEditContext from '../TourEditContext';

type RouteListDotsProps = {
  children: React.ReactNode;
};

const TOP_VALUE = 40;

const RouteListDots: React.FC<RouteListDotsProps> = ({ children }) => {
  const [height, setHeight] = useState(0);
  const { tourItems, routeInfo } = useContext(TourEditContext);
  const { md } = useBreakpoint();

  const measuredRef = useCallback(
    node => {
      if (node !== null && tourItems.length >= 2) {
        const { top: listTop } = node.getBoundingClientRect();

        // FIXME: brittle, may break if jsx structure changes. Can be improved.
        const lastStop =
          node.children[0].children[0].children[0].children[
            tourItems.length - 1
          ];

        const { top: lastStopTop } = lastStop.getBoundingClientRect();

        setHeight(lastStopTop - listTop);
      } else {
        setHeight(0);
      }
    },
    // TODO: may need to re-render on other context values
    [tourItems, routeInfo],
  );

  return (
    <StyledListDotContainer $height={height} ref={measuredRef} $md={md}>
      {children}
    </StyledListDotContainer>
  );
};

export default RouteListDots;

const StyledListDotContainer = styled.div<{ $height: number; $md: boolean }>`
  height: 100%;
  &::before {
    content: '';
    position: absolute;
    width: 1px;
    height: ${({ $height }) => `${$height}px`};
    top: ${TOP_VALUE}px;
    left: ${({ $md }) => ($md ? '38px' : '26px')};
    border-right: 7px dotted #d9d9d9;
  }
`;
